import React from 'react';
import classNames from 'classnames/bind';
import { Text } from '@carnica/ui-kit';
import { useIsMobileDimension } from '@beef/ui-kit';
import { StoresIcons } from "../StoreIcons";
import { FlexContainer } from "../FlexContainer/FlexContainer";
import ArrowIcon from "./assets/Arrow.svg";
import styles from "./styles.pcss";
import { connector } from "./connector";
var cx = classNames.bind(styles);
export var _AppBlock = function _AppBlock(_ref) {
  var storeLinks = _ref.storeLinks,
    icons = _ref.icons,
    texts = _ref.texts,
    qrCodeImage = _ref.qrCodeImage,
    theme = _ref.theme;
  var isMobile = useIsMobileDimension();
  return /*#__PURE__*/React.createElement("div", {
    className: cx('app'),
    "data-t-id": "components-AppBlock"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "s"
  }, texts.downloadApp), /*#__PURE__*/React.createElement(FlexContainer, {
    className: cx('app__install'),
    direction: "row",
    gap: isMobile ? 16 : 24
  }, !isMobile && /*#__PURE__*/React.createElement("img", {
    alt: "qr-code",
    className: cx('app__install-qr'),
    src: qrCodeImage
  }), /*#__PURE__*/React.createElement(FlexContainer, {
    direction: "column",
    fullWidth: true,
    gap: 16
  }, /*#__PURE__*/React.createElement(StoresIcons, {
    icons: icons,
    storeLinks: storeLinks,
    theme: theme,
    "data-t-id": "components-AppBlock"
  }), !isMobile && /*#__PURE__*/React.createElement(FlexContainer, {
    className: cx('app__install-text'),
    direction: "column",
    gap: 4
  }, /*#__PURE__*/React.createElement(Text, {
    color: "secondary",
    variant: "caption-medium",
    "data-t-id": "components-AppBlock"
  }, texts.scanQr), /*#__PURE__*/React.createElement(ArrowIcon, null)))));
};
export var AppBlock = connector(_AppBlock);